import React from 'react';

export const ArrowRight = ({ className = '', strokeWidth = '' }) => (
  <svg
    className={className}
    width="21"
    height="38"
    viewBox="0 0 21 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke="currentColor"
      strokeWidth={strokeWidth}
      d="M2.46161 0.984551C2.1631 0.989111 1.87274 1.08264 1.62768 1.25316C1.38262 1.42368 1.19402 1.66345 1.086 1.94177C0.977988 2.22009 0.955474 2.52431 1.02134 2.8155C1.08721 3.10669 1.23847 3.37161 1.45575 3.57635L17.3464 19.0002L1.45575 34.424C1.31122 34.5605 1.19524 34.7243 1.11457 34.9059C1.03389 35.0876 0.990118 35.2835 0.985798 35.4822C0.981477 35.6809 1.01669 35.8785 1.0894 36.0635C1.1621 36.2485 1.27085 36.4172 1.40931 36.5598C1.54778 36.7025 1.71321 36.8161 1.89598 36.8942C2.07876 36.9724 2.27524 37.0134 2.474 37.0149C2.67277 37.0165 2.86986 36.9785 3.05382 36.9032C3.23778 36.8279 3.40494 36.7168 3.5456 36.5763L20.5456 20.0763C20.6896 19.9365 20.804 19.7692 20.8822 19.5844C20.9603 19.3995 21.0006 19.2009 21.0006 19.0002C21.0006 18.7995 20.9603 18.6008 20.8822 18.416C20.804 18.2311 20.6896 18.0638 20.5456 17.924L3.5456 1.424C3.40355 1.28189 3.23441 1.16977 3.0482 1.09428C2.86199 1.01879 2.66252 0.981474 2.46161 0.984551Z"
      fill="currentColor"
    />
  </svg>
);
